import {useMutation} from '@apollo/client'
import {Form} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {ANULAR_VENTA} from '../../graphql/mutations/ventaMutations'
import {IDataResAnular} from '../../graphql/types/ventasType'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {Spinner} from '../Spinner'

interface IModalCancelProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  idVenta: string
}

export const ModalCancelVenta: React.FC<IModalCancelProps> = ({
  isOpen,
  onClose,
  idVenta,
  refetch,
}) => {
  const [gqlAnularVenta, {data, loading, error}] = useMutation<IDataResAnular>(ANULAR_VENTA)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.cancelSale.success) {
      toast.success('Venta anulada correctamente')
      onClose()
      refetch()
    } else if (data.cancelSale.errors) {
      toast.error('Error: ' + data.cancelSale.errors.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const hanldeSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {description} = Object.fromEntries(new FormData(e.currentTarget))
    if (!description) return
    gqlAnularVenta({
      variables: {
        input: {
          saleId: idVenta,
          description,
        },
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className='d-flex align-items-center gap-2 text-danger'>
          <i className='fs-1 bi bi-exclamation-circle mt-1' style={{color: 'inherit'}} />
          ¡CUIDADO!
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={hanldeSubmit}>
        <Modal.Body>
          <h4 className='text-center'>Esta acción anulará la venta</h4>
          <Form.Group className='mb-3' controlId='exampleForm.ControlTextarea1'>
            <Form.Label>Descripción</Form.Label>
            <Form.Control as='textarea' rows={3} name='description' required minLength={4} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' type='button' onClick={onClose}>
            Cancelar
          </Button>
          <Button
            className='d-flex align-items-center gap-2'
            variant='danger'
            type='submit'
            disabled={loading}
          >
            {loading && <Spinner size='16px' color='light' />}
            Anular
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
